export default __webpack_public_path__ + "static/media/nut.4c82e224.svg";